import _ from 'lodash'
import { Component } from 'react'
import { connect } from 'react-redux'

import CrudTable from '../../../shared/CrudTable'

const tableDefinition = [
  {
    title: 'Type',
    displayFn: v => v.typeOfPlanComponent
  },
  {
    title: 'Name',
    displayFn: v => v.name
  },
  {
    title: 'Vendor Name',
    displayFn: v => v.vendorName
  },
  {
    title: 'Phone',
    displayFn: v => v.phoneNumber
  },
  {
    title: 'Website',
    displayFn: v => v.website
  },
  {
    title: 'Page in Plan/Guide',
    displayFn: v => v.pageInPlanGuide
  },
  {
    title: 'Description',
    displayFn: v =>
      (_.get(v, 'description', 'None') || '').split('\n').map((item, key) => (
        <span key={key}>
          {item}
          <br />
        </span>
      ))
  }
]

class PlanComponents extends Component {
  constructor (props) {
    super(props)
    const { clients: propClients, clientProfile: propClientProfile } =
      this.props
    const clients = _.filter(propClients, {
      clientName: propClientProfile
    })

    const clientProfileName = _.get(clients, '0.display', 'none')

    this.urls = {
      get: () => `/crm/planComponents/${clientProfileName}`
    }

    this.mapFns = {
      toForm: a => a
    }
  }

  render () {
    const { inModal } = this.props
    return (
      <div className='main'>
        <CrudTable
          entryType='Plan Component'
          tableDefinition={tableDefinition}
          urlFns={this.urls}
          mapFns={this.mapFns}
          readOnly={inModal}
        />
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  clientProfile: _.get(redux, 'patient.clientName'),
  clients: _.get(redux, 'globalVars.clients', [])
})

export default connect(mapStateToProps)(PlanComponents)
